import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import helpCenterEmbedRoutes from './helpcenter/helpCenterEmbed.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import emailSequencesRoutes from './emailSequences/emailSequences.routes';
import whatsappGroupsRoutes from './whatsappGroups/whatsappGroups.routes';
import instagramAutomationRoutes from './instagramAutomation/instagramAutomation.routes';
import facebookAutomationRoutes from './facebookAutomation/facebookAutomation.routes';
import voipCallsRoutes from './voipCalls/voipCalls.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import { routes as hubRoutes } from './hub/hub.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import KanbanView from './kanban/KanbanView.vue';
import TasksApp from './tasks/TasksApp.vue';
import PermutasView from './permutas/PermutasView.vue';
import InternalChatView from './internal-chat/InternalChatView.vue';
import AutomationLogsPage from './automationLogs/AutomationLogsPage.vue';
import DashboardAppWrapper from './dashboard-apps/DashboardAppWrapper.vue';
import NoAccounts from './noAccounts/Index.vue';
import OnboardingAccountDetails from './onboarding/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        {
          path: frontendURL('accounts/:accountId/dashboard_apps/:id'),
          name: 'dashboard_apps_show',
          component: DashboardAppWrapper,
          meta: {
            permissions: ['administrator', 'agent'],
            icon: 'i-ri-apps-line',
            label: 'DASHBOARD_APPS',
          },
          props: true,
        },
        {
          path: frontendURL('accounts/:accountId/kanban'),
          name: 'kanban_board',
          component: KanbanView,
          meta: {
            permissions: [
              'administrator',
              'agent',
              'kanban_manage',
              'kanban_view',
            ],
            featureFlag: 'kanban_board',
          },
        },
        {
          path: frontendURL('accounts/:accountId/tasks'),
          name: 'tasks',
          component: TasksApp,
          meta: {
            permissions: ['administrator', 'agent', 'tasks_view'],
          },
        },
        {
          path: frontendURL('accounts/:accountId/automation-logs'),
          name: 'automation_logs',
          component: AutomationLogsPage,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
        {
          path: frontendURL('accounts/:accountId/permutas'),
          name: 'permutas_index',
          component: PermutasView,
          meta: {
            permissions: ['administrator', 'agent'],
            featureFlag: 'permutas',
          },
        },
        {
          path: frontendURL('accounts/:accountId/internal-chat'),
          name: 'internal_chat',
          component: InternalChatView,
          meta: {
            permissions: ['administrator', 'agent', 'team_chat_view'],
          },
        },
        ...captainRoutes,
        ...hubRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...helpCenterEmbedRoutes.routes,
        ...campaignsRoutes.routes,
        ...emailSequencesRoutes.routes,
        ...whatsappGroupsRoutes.routes,
        ...instagramAutomationRoutes.routes,
        ...facebookAutomationRoutes.routes,
        ...voipCallsRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_account_details',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingAccountDetails,
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
